<template>
 <Card title="代理信息" class="app-list">
    <div class="content">
      <Form
        autocomplete="off"
        class="form"
        hide-required-mark
        label-position="left"
        ref="form"
        :model="form"
        :rules="rule"
        :label-width="80"
      >
        <FormItem label="姓名" prop="real_name">
          <Input v-if="isEdit" v-model="form.real_name" clearable />
          <span v-else>{{ data.real_name }}</span>
        </FormItem>
        <FormItem label="邀请码" prop="invite">
          <Input v-if="isEdit" v-model="form.invite" clearable />
          <span v-else>{{ data.invite }}</span>
        </FormItem>
        <FormItem label="账号" prop="username">
          <Input v-if="isEdit" autocomplete="off" v-model="form.username" clearable />
          <span v-else>{{ data.username }}</span>

        </FormItem>
        <FormItem label="手机" prop="mobile">
          <Input v-if="isEdit" autocomplete="off" v-model="form.mobile" clearable />
          <span v-else>{{ data.mobile }}</span>
        </FormItem>
        <FormItem label="邮箱" prop="email">
          <Input v-if="isEdit" autocomplete="off" v-model="form.email" clearable />
          <span v-else>{{ data.email }}</span>
        </FormItem>
        <FormItem label="位置" prop="position">
          <Input v-if="isEdit" autocomplete="off" v-model="form.position" clearable />
          <span v-else>{{ data.position }}</span>

        </FormItem>
        <FormItem label="注册时间" prop="create_at">
          <!-- <Input v-if="isEdit" autocomplete="off" v-model="form.create_at" clearable />
          <span v-else>{{ data.create_at }}</span> -->
          <span >{{ data.create_at }}</span>
        </FormItem>
		<div v-if="false">
			<FormItem v-if="!isEdit">
			  <Button  type="primary" @click="isEdit = !isEdit">修改</Button>
			</FormItem>
			<FormItem v-else>
			  <Button type="primary" @click="handleSubmit('form')">提交</Button>
			  <Button @click="isEdit = !isEdit" style="margin-left: 8px"
			    >取消</Button
			  >
			</FormItem>
		</div>
      </Form>
    </div>
  </Card>
</template>

<script>
import { getProxyInfo } from "@/service/api.js";
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback("手机号格式不正确");
      } else {
        callback();
      }
    };
    return {
      isEdit: false,
      data: {},
      form: {},
      rule: {
        account: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    // 测试数据，记得删
    // this.form = {
    //   account: "test",
    //   phone: "13900000000",
    //   email: "tgegehre@qq.com",
    //   password: "123456",
    // };
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        id: window.sessionStorage.getItem("proxyId"),
      };
      getProxyInfo(params)
        .then((res) => {
          let data = res.data;
          console.log(data);
          if (data.code == 0) {
            this.data = data.data;
            this.form = JSON.parse(JSON.stringify(data.data));
          } else {
            this.$Message.error(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$Message.error("获取失败!");
        });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        console.log(valid);
        if (valid) {
          let params = {
            username: this.form.account,
            mobile: this.form.phone,
            email: this.form.email,
            password: this.form.password,
          };

          console.log(params, "params");
          addStore(params)
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$Message.success("添加成功!");
                this.$refs[name].resetFields();
              } else {
                 this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg||"操作失败！",
            });

              }
            })
            .catch((err) => {
              console.log(err);
              this.$Message.error("添加失败!");
            });
        } else {
          this.$Message.error({
            content: "表单内容不正确,请检查表单内容！",
            duration: 5,
          });
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.app-list {
  flex: 1;
  margin-top: 30px;
  height: max-content;
  .content {
    // padding: 50px;
	padding: 20px;
    background-color: #fff;
    border-radius: 3px;
    // box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    .form {
      width: 350px;
    }
  }
}
</style>
